import { stylesheet, style } from 'typestyle';

import { regularGrayText } from '@styles/general';
import { moreButton, lightGrayButton } from '@styles/buttons';

import { height } from './dyor';

export default {
  detail: ({ chainPosition, containerWidth }) => {
    const MARGIN = 10;

    const chainSectionWidth = Math.round(containerWidth / 3);
    const width = 320;
    let left = MARGIN;
    // 5 here is half of the caret width, NOT the margin
    let caretLeft = 50 - MARGIN - 5;

    if (chainPosition === 2) {
      left = chainSectionWidth + MARGIN;
    }

    // Shift left if it will render off the right side of the screen
    if (containerWidth < left + width + MARGIN) {
      left = containerWidth - width - MARGIN;
    }

    // If we are now going to render < 5 px from the left side of the screen,
    // shift right again. Max width will take care of making sure we don't
    // render off the right side of the screen.
    if (left < MARGIN) {
      left = MARGIN;
    }

    if (
      chainPosition === 2 &&
      containerWidth < chainSectionWidth + width + MARGIN
    ) {
      // the center of the icon is 50px from the left of the section
      const secondIconLeft = chainSectionWidth + 50;

      // 5 here is half of the caret width, NOT the margin
      caretLeft = secondIconLeft - left - 5;
    }

    return style({
      display: 'flex',
      flexDirection: 'row',
      position: 'absolute',
      top: height - 1,
      left,
      width,
      maxWidth: `calc(100% - ${2 * MARGIN}px)`,
      background: 'white',
      borderRadius: 5,
      border: '1px solid #ebebec',
      boxShadow: '0 6px 35px rgba(135, 135, 135, 0.24)',
      color: 'rgb(127, 127, 127)',
      padding: '15px 20px 15px',
      cursor: 'default',
      zIndex: 300,

      $nest: {
        '&::after': {
          color: 'transparent',
          content: '"▲"',
          display: 'block',
          fontSize: 8,
          left: caretLeft,
          lineHeight: '22px',
          position: 'absolute',
          textShadow:
            '0 0 0 white, 1px 1.5px 0 white, -1px 1.5px 0 white, 1.5px 2.5px 0 white, -1.5px 2.5px 0 white, -1px 0 0 #e6e5e5, 0 -2px 0 #e6e5e5, 1px 0 0 #E6E5E6',
          top: -14,
          transform: 'scaleX(2) rotate(0deg)'
        }
      }
    });
  },
  ...stylesheet({
    detailImage: {
      marginRight: 10,

      img: {
        marginTop: 10,
        maxWidth: 50
      }
    },

    detailPrice: {
      color: '#21528d',
      fontWeight: 'bold',
      fontSize: 15
    },

    viewLink: {
      ...moreButton,

      marginRight: 10
    },

    changeLink: {
      ...lightGrayButton
    },

    deleteLink: {
      color: regularGrayText,
      textDecoration: 'underline',
      float: 'right',
      marginRight: 30,
      fontWeight: 'normal'
    },

    links: {
      order: 3
    }
  })
};
